import { useEffect, useRef } from 'react';
import { App } from '@capacitor/app';
import useFetch from 'use-http';

const useAppActivityMonitor = (user, logout) => {
  const { post, response } = useFetch();
  const listenerRef = useRef(null);

  const clearListener = async () => {
    if (listenerRef.current) {
      await listenerRef.current.remove();
      listenerRef.current = null;
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    void (async () => {
    if (user && user.id) {
      await clearListener();
      listenerRef.current = await App.addListener('appStateChange', async ({ isActive: active }) => {
        if (active) {
          try {
            await post('/users/activity/access'); // this call is made when the app is foregrounded
            if (!response.ok) {
              throw new Error('Failed to update user activity');
            }
          } catch (e) {
            console.error(e);
            if (response.status === 401) {
              logout();
            }
          }
        }
      });
    } else {
      await clearListener();
    }

    return () => {
      clearListener();
    };
  })();
  }, [user]);
};

// eslint-disable-next-line import/prefer-default-export
export default useAppActivityMonitor;
